import React from 'react'
import { Box, Container, Typography, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const NotFound: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h2" sx={{ fontWeight: 800, mb: 1 }}>404</Typography>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>{t('notFound.title')}</Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>{t('notFound.lead')}</Typography>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button component={RouterLink} to="/" variant="contained">{t('notFound.backHome')}</Button>
        <Button component={RouterLink} to="/impressum">{t('nav.imprint')}</Button>
        <Button component={RouterLink} to="/datenschutz">{t('nav.privacy')}</Button>
      </Box>
    </Container>
  )
}

export default NotFound

